import { Dropdown, Modal } from "reactstrap"
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons"
import { Field, Form } from "react-final-form";
import styles from './AddChannels.module.scss'
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import OutlinedFormInput from "../../../../Finance/components/OutlinedFormInput/OutlinedFormInput"
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri';
import { formActionTypes, SalesMarketingSectionTypes } from "../../../../../interfaces/interfaces"
import { onBlurFormatNumber, parseNumberForDB } from "../../../../../components/functions/utilities";
import { useEffect, useState } from "react";
import SelectMetricCustom from "../../../../Finance/components/SelectMetric/SelectMetricCustom";
import DropdownFilter from "../../../../../components/chart/components/ExpandedCohort/FilterDropdown/DropdownFilter";
import PlatformSelect from "./PlatformSelect";
import { v1 as uuidv1 } from "uuid";
import { BsFillExclamationCircleFill } from "react-icons/bs";
import DeleteConfirmation from "./DeleteConfirmation";

type Props = {
  isOpen: boolean,
  setIsOpen: Function,
  actionType: formActionTypes,
  sectionType: SalesMarketingSectionTypes,
  salesOptions: any,
  title: string,
  handleChange: Function,
  initialValues: any,
  monthYear: string
}

const AddSales = ({
  isOpen, setIsOpen, actionType, sectionType, salesOptions, title, handleChange, initialValues, monthYear
}: Props) => {

  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  useEffect(() => {
    console.log('initialValues', initialValues)
  }, [initialValues])

  const submitForm = (values) => {
    if (actionType == formActionTypes.add) {
      // Add Channel
      if (sectionType == SalesMarketingSectionTypes.sales) {
        const uuid = uuidv1()
        const salesObj = {
          uuid,
          label: values.label,
          currMonthValue: values.sales,
          isUserAdded: true
        }
        const adsObj = {
          uuid: `linked-${uuid}`,
          label: `${values.label} Ads`,
          currMonthValue: values.adSpend,
          linkedSales: uuid,
          isUserAdded: true
        }
        handleChange(salesObj, SalesMarketingSectionTypes.sales, actionType)
        handleChange(adsObj, SalesMarketingSectionTypes.ads, actionType)
      } else {
        const uuid = uuidv1()
        const adsObj = {
          uuid,
          label: values.label,
          currMonthValue: values.adSpend,
          linkedSales: values.linkedSales,
          isUserAdded: true
        }
        handleChange(adsObj, SalesMarketingSectionTypes.ads, actionType)
      }
    } else {
      console.log('Updates', values)
      if (sectionType == SalesMarketingSectionTypes.sales) {
        const salesObj = {
          uuid: values.uuid,
          label: values.label,
          currMonthValue: values.sales,
          adSpend: values.adSpend
        }
        handleChange(salesObj, SalesMarketingSectionTypes.sales, actionType)
      } else {
        const adsObj = {
          uuid: values.uuid,
          label: values.label,
          currMonthValue: values.adSpend,
          linkedSales: values.linkedSales ?? -1
        }
        handleChange(adsObj, SalesMarketingSectionTypes.ads, actionType)
      }
    }
    setIsOpen()
  }
  const handleDelete = (obj) => {
    handleChange(obj, sectionType, formActionTypes.delete)
    setIsOpen()
  }

  return (
    <>
      <Modal isOpen={isOpen} size='md' centered={true}>
        <div className={styles.formRootContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.title}>
              {title}
            </div>
            <div className={styles.actionButtonContainer}>
              <MeritoButton type="secondary-1" icon={<CloseIcon />} onlyIcon={true} onClick={(e) => {
                e.stopPropagation();
                setIsOpen();
              }} />
            </div>
          </div>

          <Form
            initialValues={initialValues}
            validate={(values) => {
              return {}
            }}
            onSubmit={(values) => {
              submitForm(values);
            }} render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, mutators } }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <div className={styles.formBodyContainer}>
                    <Field
                      name="label"
                      validate={(value) => {
                        if (!value) {
                          return `Enter channel name`
                        }
                      }}
                    >
                      {(props) => (
                        <OutlinedFormInput
                          {...props.input}
                          disabled={actionType == formActionTypes.edit}
                          label="Channel Name"
                          name="label"
                          value={props.input.value}
                          onChange={props.input.onChange}
                          error={props.meta.error}
                          touched={props.meta.touched}
                          maxLength={70}
                        />

                      )}
                    </Field>
                    {
                      sectionType == SalesMarketingSectionTypes.sales ?
                        <Field
                          name="sales"
                          validate={(value) => {
                            if (!value) {
                              return `Enter sales amount`
                            }
                          }}
                        >
                          {(props) => (

                            <OutlinedFormInput
                              {...props.input}
                              inpuType="number"
                              label={`Sales (${monthYear})`}
                              name={props.input.name}
                              value={props.input.value}

                              allowDecimals={true}
                              onChange={(e) => {
                                const numericValue = parseNumberForDB(e.target.value, true);
                                // console.log('numeric value', numericValue)
                                props.input.onChange(numericValue);
                              }}
                              error={props.meta.error}
                              touched={props.meta.touched}
                              onBlur={(e) => {
                                const value = props.input.value;
                                console.log('value', value);
                                const formattedValue = onBlurFormatNumber(value, 2);
                                props.input.onChange(formattedValue);
                                // console.log('inputValue', value)
                                // if (props.input.value != currentMonthValue?.apiCost) {
                                //   batch(() => {
                                //     change(`${name}.inEffectValue`, MetricValueType.updatedCost);
                                //     change(`${name}.editedBy`, userId);
                                //     change(`${name}.editedTime`, new Date());
                                //   })
                                // }
                                props.input.onBlur(e);
                              }}
                              unitPlaceHolder='₹'
                              unitPosition="left"
                              isCurrency={true}
                            />
                          )}
                        </Field> : null
                    }
                    <Field
                      name="adSpend"
                      validate={(value) => {
                        if (!value) {
                          return `Enter ad spend amount`
                        }
                      }}
                    >
                      {(props) => (

                        <OutlinedFormInput
                          {...props.input}
                          inpuType="number"
                          label={`Ad Spend (${monthYear})`}
                          name={props.input.name}
                          value={props.input.value}

                          allowDecimals={true}
                          onChange={(e) => {
                            const numericValue = parseNumberForDB(e.target.value, true);
                            console.log('numeric value', numericValue)
                            props.input.onChange(numericValue);
                          }}
                          error={props.meta.error}
                          touched={props.meta.touched}
                          onBlur={(e) => {
                            const value = props.input.value;
                            console.log('value', value);
                            const formattedValue = onBlurFormatNumber(value, 2);
                            props.input.onChange(formattedValue);
                            console.log('inputValue', value)
                            // if (props.input.value != currentMonthValue?.apiCost) {
                            //   batch(() => {
                            //     change(`${name}.inEffectValue`, MetricValueType.updatedCost);
                            //     change(`${name}.editedBy`, userId);
                            //     change(`${name}.editedTime`, new Date());
                            //   })
                            // }
                            props.input.onBlur(e);
                          }}
                          unitPlaceHolder='₹'
                          unitPosition="left"
                          isCurrency={true}
                        />
                      )}
                    </Field>
                    {
                      sectionType == SalesMarketingSectionTypes.ads ?
                        <Field
                          name="linkedSales"
                          validate={(value) => {
                            if (!value) {
                              return "Please select a metric"
                            }
                          }}
                        >
                          {(props) => (
                            <PlatformSelect value={props.input.value} handleSelectedValue={(value) => {
                              console.log('selectedMetric', value)
                              props.input.onChange(value);
                            }} options={[
                              ...salesOptions,
                              {
                                "uuid": "-1",
                                "label": "Others"
                              }
                            ]} />
                          )}
                        </Field> : null
                    }
                  </div>
                  <div className={styles.footerContainer}>
                    <div className={styles.leftContainer}>
                      {
                        actionType == formActionTypes.edit ?
                          <MeritoButton btnText={'Delete'} type="destructive-ghost" onClick={() => {
                            if (initialValues?.isUserAdded && Object.keys(initialValues).includes('prevMonthValue')) {
                              console.log('Popup will be shown for delete confirmation');
                              setShowDeleteWarning(true);
                            } else {
                              handleDelete(initialValues)
                            }
                          }} onlyIcon={true} icon={<DeleteIcon />} />
                          : null
                      }
                    </div>
                    <div className={styles.rightContainer}>
                      <MeritoButton btnText="Cancel" type="tertiary" onClick={() => setIsOpen()} />
                      <MeritoButton disabled={pristine || hasValidationErrors} btnText={actionType == formActionTypes.edit ? "Update" : "Add"} type="primary-1" onClick={() => {
                        handleSubmit();
                      }} />
                    </div>

                  </div>
                </form>
              )
            }} />

        </div>
      </Modal>
      <DeleteConfirmation
        initialValues={initialValues}
        isOpen={showDeleteWarning}
        setIsOpen={(isOpen) => {
          setShowDeleteWarning(isOpen);
        }}
        handleChange={handleChange}
        sectionType={sectionType}
        closeChannelPopup={() => setIsOpen(false)}
      />
    </>
  )
}

export default AddSales;